import axios from 'axios';
import { toast } from 'react-toastify';

class Tdm {
  baseURL = process.env.REACT_APP_BASE_URL + `/api/v2/tdm`;
  static headers = {}
  constructor(api) {
    this.api = api
    this.headers = { Authorization: `Bearer ${api.token}` };
  }

  async getTdmRoutes() {
    const { data } = await axios.get(`${this.baseURL}/routes`, {
      headers: this.headers,
    });
    return data;
  }
}
export default Tdm;
